function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _reactNative = require("react-native-web");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["slug", "label", "isActive", "onPress", "style", "hide"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Component = (0, _react.forwardRef)(function (_ref, ref) {
  var slug = _ref.slug,
    label = _ref.label,
    isActive = _ref.isActive,
    onPress = _ref.onPress,
    style = _ref.style,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var activeDuration = 250;
  var notActiveDuration = 125;
  var tickContainerSize = 1.125 * _reactNative.PixelRatio.getFontScale() * _styles2.baseSize;
  var _useStyles = (0, _styles.useStyles)({
      tickContainerSize: tickContainerSize
    }),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  var _stylingActive = {
    opacity: 1,
    scale: 1,
    padding: 0,
    width: tickContainerSize
  };
  var _stylingNotActive = {
    opacity: 0,
    scale: 0.7,
    padding: tickContainerSize / 2,
    width: 0
  };
  var _styling = isActive ? _stylingActive : _stylingNotActive;
  var _opacity = (0, _react.useRef)(new _reactNative.Animated.Value(_styling.opacity)).current;
  var _scale = (0, _react.useRef)(new _reactNative.Animated.Value(_styling.scale)).current;
  var _padding = (0, _react.useRef)(new _reactNative.Animated.Value(_styling.padding)).current;
  var _width = (0, _react.useRef)(new _reactNative.Animated.Value(_styling.width)).current;
  var _showTick = _reactNative.Animated.sequence([_reactNative.Animated.parallel([_reactNative.Animated.timing(_padding, {
    toValue: _stylingActive.padding,
    duration: activeDuration,
    useNativeDriver: false
  }), _reactNative.Animated.timing(_width, {
    toValue: _stylingActive.width,
    duration: activeDuration,
    useNativeDriver: false
  })]), _reactNative.Animated.parallel([_reactNative.Animated.timing(_opacity, {
    toValue: _stylingActive.opacity,
    duration: activeDuration,
    useNativeDriver: false
  }), _reactNative.Animated.timing(_scale, {
    toValue: _stylingActive.scale,
    duration: activeDuration,
    useNativeDriver: false
  })])]);
  var _hideTick = _reactNative.Animated.sequence([_reactNative.Animated.parallel([_reactNative.Animated.timing(_opacity, {
    toValue: _stylingNotActive.opacity,
    duration: notActiveDuration,
    useNativeDriver: false
  }), _reactNative.Animated.timing(_scale, {
    toValue: _stylingNotActive.scale,
    duration: notActiveDuration,
    useNativeDriver: false
  })]), _reactNative.Animated.parallel([_reactNative.Animated.timing(_padding, {
    toValue: _stylingNotActive.padding,
    duration: notActiveDuration,
    useNativeDriver: false
  }), _reactNative.Animated.timing(_width, {
    toValue: _stylingNotActive.width,
    duration: notActiveDuration,
    useNativeDriver: false
  })])]);
  var _onPress = function _onPress() {
    onPress == null ? void 0 : onPress(slug);
  };
  (0, _react.useEffect)(function () {
    if (hide) return;
    if (isActive) {
      _hideTick.stop();
      _showTick.start();
    } else {
      _showTick.stop();
      _hideTick.start();
    }
  }, [_hideTick, _showTick, hide, isActive]);
  (0, _react.useEffect)(function () {
    if (!hide) return;
    _opacity.setValue(_styling.opacity);
    _scale.setValue(_styling.scale);
    _padding.setValue(_styling.padding);
    _width.setValue(_styling.width);
  }, [_opacity, _padding, _scale, _styling.opacity, _styling.padding, _styling.scale, _styling.width, _width, hide, isActive]);
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.container, isActive && styles.container_active, style, hide && {
      opacity: 0
    }],
    ref: ref
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.blank,
      label: label,
      hideLabel: true,
      onPress: _onPress,
      containerStyle: styles.buttonContainer,
      textStyle: styles.buttonText,
      testID: "Filter",
      state: {
        disabled: hide
      }
    }), (0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
      style: [styles.tickContainer, {
        opacity: _opacity,
        transform: [{
          scale: _scale
        }],
        width: _width
      }],
      children: (0, _jsxRuntime.jsx)(Icons.Tick, {
        color: COLORS.snuff,
        size: (0, _styles2.getREM)(0.5)
      })
    }), (0, _jsxRuntime.jsx)(_reactNative.Animated.Text, {
      style: [styles.text, {
        paddingLeft: _padding,
        paddingRight: _padding
      }],
      children: label
    })]
  }));
});
var Filter = exports.Filter = (0, _react.memo)(Component);